import Http from '@/common/http'
export default class Package {
  static getJdFilterCriteria (param = {}) {
    return Http.post('/mp/Jd_Package/getJdFilterCriteria', param)
  }
  static savePackageInfo (param = {}) {
    return Http.post('/mp/Jd_Package/savePackageInfo', param)
  }
  static getPackageList (param = {}) {
    return Http.get('/mp/Jd_Package/getPackageList', param)
  }
  static delPackageInfo (param = {}) {
    return Http.post('/mp/Jd_Package/delPackageInfo', param)
  }

  
  static getMiniFilterCriteria (param = {}) {
    return Http.post('/mp/Sp_Package/getFilterCriteria', param)
  }
  static saveMiniPackageInfo (param = {}) {
    return Http.post('/mp/Sp_Package/savePackageInfo', param)
  }
  static getMiniPackageList (param = {}) {
    return Http.get('/mp/Sp_Package/getPackageList', param)
  }
  static delMiniPackageInfo (param = {}) {
    return Http.post('/mp/Sp_Package/delPackageInfo', param)
  }
  static getMiniPackageStatusList (param = {}) {
    return Http.post('/mp/Sp_Package/getPackageStatusList', param)
  }
  static getMiniPackageRelationSetting (param = {}) {
    return Http.post('/mp/Sp_Package/getPackageRelationSetting', param)
  }
  static saveMiniPackageInfoByUpload (param = {}) {
    return Http.post('/mp/Sp_Package/savePackageInfoByUpload', param)
  }
}
